import $ from 'jquery';
import prestashop from 'prestashop';
import noUiSlider from 'nouislider';
import daterangepicker from 'daterangepicker';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
let dateRangePicker = false; 
let dateRangeSelected = false; 
let monthChangeInProgress = false; 

$(document).ready(() => {

  const initState = {
    rendered_facets: $('#search_filters').clone(),

    rendered_products_top: $('#js-product-list-top').clone(),
    rendered_products: $('#js-product-list').clone(),
    rendered_products_bottom: $('#js-product-list-bottom').clone(),

    rendered_products_top_universe: $('#js-product-list-top-universe').clone(),
    rendered_products_universe: $('#js-product-list-universe').clone(),
    rendered_products_bottom_universe: $('#js-product-list-top-universe-filters').clone(),
  }

  setupRangeInput();

  const parseSearchUrl = function (event) {
    if (event.target.dataset.searchUrl !== undefined) {
      return event.target.dataset.searchUrl;
    }

    if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
      throw new Error('Can not parse search URL');
    }

    return $(event.target).parent()[0].dataset.searchUrl;
  };

  $('body').on('change', '#search_filters input[data-search-url]', function (event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('change', '#search_filters select', function (event) {
    prestashop.emit('updateFacets', $(event.target).val());
  });

  $('body').on('click', '.js-search-link', function (event) {
    event.preventDefault();
    prestashop.emit('updateFacets', $(event.target).closest('a').get(0).href);
  });

  $('body').on('change', '.js-search-select', function (event) {
    event.preventDefault();
    prestashop.emit('updateFacets', $(event.target).val());
  });

  prestashop.on('updateProductList', (data) => {
    updateProductListDOM(data);
    setupRangeInput();

    window.scrollTo(0, $('#main').offset().top - 50);
  });

  window.onpopstate = function(event) {
    updateProductListDOM(event.state ? event.state : initState);
    setupRangeInput();
  };
 
  changeEventsDateLocation();

});

function updateProductListDOM (data) {
  $('#search_filters').replaceWith(data.rendered_facets);

  $('#js-product-list-top').replaceWith(data.rendered_products_top);
  $('#js-product-list').replaceWith(data.rendered_products);
  $('#js-product-list-bottom').replaceWith(data.rendered_products_bottom);

  $('#js-product-list-top-universe').replaceWith(data.rendered_products_top_universe);
  $('#js-product-list-universe').replaceWith(data.rendered_products_universe);
  $('#js-product-list-top-universe-filters').append(data.rendered_facets);
}

function setupRangeInput () {

  let sliders = document.getElementsByClassName('js-facet-range-slider');

  for (var i = 0; i < sliders.length; i++) {
    let slider = sliders[i];

    noUiSlider.create(slider, {
      step: 1,
      connect: [false, true, false],
      start: [
        parseInt($(slider).data('from')),
        parseInt($(slider).data('to'))
      ],
      range: {
        min: [parseInt($(slider).data('min'))],
        max: [parseInt($(slider).data('max'))]
      },
      format: {
        from: (value) => fixFloat(value),
        to: (value)   => fixFloat(value)
      }
    });

    slider.noUiSlider.on('update', onSliderUpdate);
    slider.noUiSlider.on('change', onSliderChange);

    $(slider).animate({ opacity: 1 }, 100);
  }

}

function onSliderChange (values) {
  prestashop.emit('updateFacets', processFacetUrl($(this.target), values));
}

function onSliderUpdate (values) {
  $(this.target).parent().find('.js-facet-range-slider-from').text(fixFloat(values[0]));
  $(this.target).parent().find('.js-facet-range-slider-to').text(fixFloat(values[1]));
}

function processFacetUrl ($target, values) {
  let url = $target.data('url');

  let filter = [
    $target.data('label'),
    $target.data('symbol')
  ].join('-');

  let query = encodeURI([
    filter,
    ...values,
  ].join('-'));

  if (!/\?q=/g.test(url)) {
    return `${url}?q=${query}`;
  }

  if (url.includes(encodeURI(filter))) {
    return url.replace(/(.+-)(\d+[\.\d]*-\d+[\.\d]*)/g, (match, $1, $2) => $1 + values.join('-'));
  }

  return `${url}/${query}`;
}

function fixFloat(val) {
  return parseFloat(val).toFixed(2);
}


var ajaxDateLocation = (data, callback) => {
  $.ajax({
    url: prestashop.urls.pages.index,
    type: "POST",
    data: data,
    dataType: 'json',
    context: document.body
  }).done(callback);
}

var changeEventsDateLocation = () => {

  if(prestashop.shop['is_location']) {

    initDateRangePicker(prestashop.shop.currentRanges);
    
    $(document).on('click', '.js-change-date', function() {
      $('.js-location-daterangepicker').click();
    });

    $(document).on('click', 'a[href="#select-date"]', function() {
     
      var dom = $('#select-date-js');
      if(dom.length) {
        window.scrollTo({
            top: dom.offset().top - (dom.outerHeight() / 2),
            behavior: 'smooth'
        });
        $('.js-location-daterangepicker').click();
      }      
      return false;
    });
    
  }

}

var initDateRangePicker = (ranges) => {

  ranges = parseRanges(ranges);  
  if(!dateRangePicker) {

    dateRangePicker = initPicker(ranges);
    dateRangePicker = dateRangePicker.data('daterangepicker');
  
    // si pas de dateRangePicker sur cette page
    if(typeof dateRangePicker == 'undefined')
      return false;

    if(prestashop.shop.selectedSlot) {
      dateRangePicker.setStartDate(moment.unix(prestashop.shop.selectedSlot[0]), dateRangePicker.locale.format);
      dateRangePicker.setEndDate(moment.unix(prestashop.shop.selectedSlot[1]), dateRangePicker.locale.format);
    } 

    // prevent custom ranges to be picked on old nav
    dateRangePicker.container.find('.drp-calendar').off("mousedown.daterangepicker", 'td.available');
    
    $(document).on('click.daterangepicker', '.next, .prev', function(e) {
        getRanges(dateRangePicker.leftCalendar.month);
    });

    $(document).on('mouseover', '.ranges li', function(e) {
      if(monthChangeInProgress) {
        return false;
      }

      const label = $(this).data('rangeKey');
      if(typeof dateRangePicker.ranges[label] == 'undefined')
        return false;

      const startMonth = dateRangePicker.leftCalendar.month;

      var dates = dateRangePicker.ranges[label];
      dateRangePicker.startDate = dates[0];
      dateRangePicker.endDate = dates[1];
      dateRangePicker.updateView();

      if(dateRangePicker.leftCalendar.month != startMonth) {
        // changement de mois par hover, on met à jour l'affichage
        monthChangeInProgress = true;
        getRanges(dateRangePicker.leftCalendar.month);
        dateRangePicker.startDate = dates[0];
        dateRangePicker.endDate = dates[1];
        dateRangePicker.updateView();
        dateRangeSelected = label;
      }
    });

  } else {
    // maj des ranges
    refreshRanges(dateRangePicker, ranges);      
  }
}

var initPicker = (ranges) => {    
    var datePicker = $('.js-location-daterangepicker').daterangepicker({
      minDate: moment().tz('Europe/Paris'),
      autoUpdateInput: false,
      alwaysShowCalendars: true,
      showCustomRangeLabel: false,
      autoApply: true,
      locale: {
        "format": "DD/MM/YYYY",
          "separator": " - ",
          "fromLabel": "De",
          "toLabel": "à",
          "weekLabel": "W",
          "daysOfWeek": [
              "di",
              "lu",
              "ma",
              "me",
              "je",
              "ve",
              "sa"
          ],
          "monthNames": [
              "Janvier",
              "Février",
              "Mars",
              "Avril",
              "Mai",
              "Juin",
              "Juillet",
              "Aout",
              "Septembre",
              "Octobre",
              "Novembre",
              "Décembre"
          ],
          "firstDay": 1
      },
      ranges: ranges
    }).on('apply.daterangepicker', function(e, picker) {
        setDateLocation(picker);

      // bug au chgt de prev next après selection
      $(document).on('click.daterangepicker', '.next, .prev', function(e) {
          getRanges(dateRangePicker.leftCalendar.month);
      });
    })

    return datePicker;
}

var getRanges = (startDate) => {
  ajaxDateLocation({
    year: moment().year(),
    currentDate: startDate.format('YYYY-MM-01'),
    action: 'DateRangeLocation',
    ajax: 1
  }, (data) => {
    if(!data.error) {
      initDateRangePicker(data.ranges);
      setTimeout(function(){ monthChangeInProgress = false; }, 1000 );  
    }
  });
}

var parseRanges = (ranges) => {
  var obj = {};

  if(!ranges)
    return obj;

  for (const range in ranges) {
    if (Object.hasOwnProperty.call(ranges, range)) {
      const label = ranges[range];
      const startEnd = JSON.parse(range);
      obj[label] =  [moment(startEnd[0]*1000).tz('Europe/Paris'), moment(startEnd[1]*1000).tz('Europe/Paris')];      
    }
  }

  return obj;
}

var refreshRanges = (picker, ranges) => {
  var start, end;
  picker.ranges = [];
  for (var range in ranges) {
      if (typeof ranges[range][0] === 'string')
          start = moment(ranges[range][0], picker.locale.format).tz('Europe/Paris');
      else
          start = moment(ranges[range][0]).tz('Europe/Paris');

      if (typeof ranges[range][1] === 'string')
          end = moment(ranges[range][1], picker.locale.format).tz('Europe/Paris');
      else
          end = moment(ranges[range][1]).tz('Europe/Paris');

      picker.ranges[range] = [start, end];
  }

  var list = '<ul>';
  for (range in  picker.ranges) {
      if(dateRangeSelected && dateRangeSelected == range ) {
        list += '<li data-range-key="' + range + '" class="active">' + range + '</li>';
        dateRangeSelected = false;
      } else {
        list += '<li data-range-key="' + range + '">' + range + '</li>';
      }
  }
  list += '</ul>';
  picker.container.find('.ranges').html(list);  
}

var refreshInputsWithDateRangePicker = (picker) => {
  const inputHome = $('.js-full-date');
  const start = picker.startDate.format('D') + ' ' + picker.locale.monthNames[picker.startDate.month()];
  const end = picker.endDate.format('D') + ' ' + picker.locale.monthNames[picker.endDate.month()];
  if(inputHome.length) {
    inputHome.addClass('date-filled');
    inputHome.html(start + '<br/>' + end);
  } else {
    $('.js-start-date').text(start);
    $('.js-end-date').text(end);
  }
}

var setDateLocation = (picker) => {
  // set cookie and refresh listing
  const year = picker.startDate.format('YYYY');
  const month =  picker.startDate.format('MM');
  // end date : on conserve pas l'heure du coup on reset au jour à minuit et pas a 23h59 59s
  const slot = JSON.stringify([picker.startDate.unix(), picker.endDate.unix() + 1 - (24 * 60 * 60)]);
  ajaxDateLocation({
    year: year,
    month: month,
    slot: slot,
    action: 'DateLocation',
    ajax: 1
  }, (data) => {
    if(data.error) {
      alert(data.errMsg);
      return;
    } 
    
    if(data.refresh) {
      if(prestashop.page.page_name == 'product' || prestashop.page.page_name == 'cart') {
        // refresh page
        window.location.reload();
      } else {
        if(prestashop.page.page_name != 'index') {
          // refresh listing products
          var url = window.location.href.replace(window.location.hash, '');
          if(url.indexOf('?') > 0)
            url += '&from-xhr';
          else
            url += '?from-xhr';
            
          $.getJSON(url, function(data) {
            updateProductListDOM(data);
          });
        }
        // update date fields infos
        refreshInputsWithDateRangePicker(picker);
      }          
    } 
  });
}


// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/listing.js